export function mapSurveyLocalization(
  countryCode: string,
  languageShortCode: string,
): string {
  return `${languageShortCode}_${countryCode}`;
}

export interface SurveyLocalizationParts {
  countryCode: string;
  languageShortCode: string;
}

export function parseSurveyLocalization(
  localization: string,
): SurveyLocalizationParts {
  const [languageShortCode = '', countryCode = ''] = localization.split('_');
  return { countryCode, languageShortCode };
}
